const WhatAwaitsYouSection = () => {
  return (
    <section id="what-awaits-you" className="w-full flex justify-center">
      <div className="w-4/5 max-w-screen-xl pt-28 pb-10">
        <h4 className="text-custom-red font-bold text-5xl sm:text-7xl">
          Seni Neler
          <br />
          Bekliyor?
        </h4>
        <div className="flex flex-col bg-[url(../../assets/images/what-awaits-you.png)] bg-bottom py-20 space-y-8 md:space-y-0">
          <div className="flex flex-col md:flex-row justify-center md:space-x-8 lg:space-x-24 space-y-8 md:space-y-0">
            <div className="flex justify-center items-end">
              <img
                width="216.57px"
                height="249.97px"
                src={require("../../assets/images/what-awaits-1.png")}
                alt="Departmanlar arası rotasyon"
              />
            </div>
            <div className="flex justify-center items-end">
              <img
                width="216.57px"
                height="249.97px"
                src={require("../../assets/images/what-awaits-2.png")}
                alt="İlgili olduğun alanda eğitim desteği"
              />
            </div>
            <div className="flex justify-center items-end">
              <img
                width="216.57px"
                height="249.97px"
                src={require("../../assets/images/what-awaits-3.png")}
                alt="Mentorluk desteği"
              />
            </div>
          </div>
          <div className="flex flex-col md:flex-row justify-center md:space-x-8 lg:space-x-24 space-y-8 md:space-y-0">
            <div className="flex justify-center items-end">
              <img
                width="216.57px"
                height="249.97px"
                src={require("../../assets/images/what-awaits-4.png")}
                alt="Hibrit çalışma modeli"
              />
            </div>
            <div className="flex justify-center items-end">
              <img
                width="216.57px"
                height="249.97px"
                src={require("../../assets/images/what-awaits-5.png")}
                alt="Global bir çalışma deneyimi"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatAwaitsYouSection;
